import ModuloEnum from "@/core/utils/ModuloEnum"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

const componentRouterView = {
    render(c) {
        return c("router-view");
    },
};


const createRegisterRoute = ({
    baseUrl,
    name,
    titleList,
    titleCreate,
    titleEdit,
    listComponent,
    formComponent,
    menu,
    othersRoutes = []
}) => ({
    path: baseUrl,
    component: componentRouterView,
    children: [{
        path: "/",
        name: `listar${name}`,
        meta: { description: titleList, menu },
        component: listComponent,
    },
    {
        path: "novo",
        name: `criar${name}`,
        meta: { description: titleCreate },
        component: formComponent,
    },
    {
        path: ":id",
        name: `editar${name}`,
        meta: { description: titleEdit },
        component: formComponent,
    },
    ...othersRoutes
    ],
});

const routes = {
    path: "/gerenciamento",
    component: componentRouterView,
    meta: {
        moduleName: "SGU",
        icon: "people",
        modulo: ModuloEnum.NAO_NECESSITA_VERIFICACAO,
        sistema: 1,
    },
    children: [
        createRegisterRoute({
            baseUrl: "perfil",
            name: "perfil",
            titleList: "Perfil",
            listComponent: () => import("./perfil/PerfilList.vue"),
            menu: { name: " Perfil ",  permissao: PrivilegiosEnum.AUDITORIA_PERFIL_ACESSAR },

        }),

        createRegisterRoute({
            baseUrl: "departamentosgu",
            name: "departamentosgu",
            titleList: "Unidade Administrativa",
            listComponent: () => import("./departamentosgu/DepartamentoSguList.vue"),
            menu: { name: " Unidade Administrativa",  permissao: PrivilegiosEnum.AUDITORIA_DEPARTAMENTO_ACESSAR },
        }),


        createRegisterRoute({
            baseUrl: "usuario",
            name: "Usuario",
            titleList: "Usuário",
            listComponent: () => import("./usuario/UsuarioList.vue"),
            menu: { name: " Usuário",  permissao: PrivilegiosEnum.AUDITORIA_USUARIO_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "associacao-perfil-usuario",
            name: "AssociacaoPerfilUsuario",
            titleList: "Associação Perfil Usuário",
            listComponent: () => import("./associacao-perfil-usuario/AssociacaoPerfilUsuarioList.vue"),
            menu: { name: " Associação Perfil Usuário",  permissao: PrivilegiosEnum.AUDITORIA_PERFIL_USUARIO_ACESSAR },

        }),

        createRegisterRoute({
            baseUrl: "configuracao-privilegios-perfil",
            name: "SguPerfilUsuario",
            titleList: "Configuração de Privilégios do Perfil",
            listComponent: () => import("./configuracao-privilegio-perfil/ConfiguracaoPrivilegioPerfilList.vue"),
            menu: { name: "Configuração de Privilégios do Perfil",  permissao: PrivilegiosEnum.AUDITORIA_PRIVILEGIOS_PERFIL_ACESSAR },
        }),


    ],

};

export default routes;
